export default class CopyToClipboard {
    private readonly button: Element;
    private readonly target: HTMLElement;
    private readonly defaultLabel: string;

    public constructor(element: Element) {
        this.button = element;
        this.defaultLabel = element.innerHTML;

        const targetSelector = element.getAttribute('data-copy-target');

        if (targetSelector === null) {
            throw new Error('data-copy-target attribute is required on CopyToClipboard element');
        }

        const target = document.querySelector(targetSelector);

        if (target === null) {
            throw new Error(`CopyToClipboard target not found: ${targetSelector}`);
        }

        this.target = target as HTMLElement;
        this.button.addEventListener('click', (e) => this.handleClick(e));
    }

    private handleClick(e: Event): void {
        e.preventDefault();

        const htmlBlob = new Blob([this.target.innerHTML], {type: 'text/html'});
        const textBlob = new Blob([this.target.innerText], {type: 'text/plain'});
        const item = new ClipboardItem({'text/html': htmlBlob, 'text/plain': textBlob});

        navigator.clipboard.write([item]).then(() => {
            this.button.innerHTML = '<span class="fas fa-check me-2 text-success"></span>Zkopírováno';
            setTimeout(() => {
                this.button.innerHTML = this.defaultLabel;
            }, 2000);
        });
    }
}
